<template>
  <div class="cooperation-page__steps" :class="{ descriptionShown }">

    <div
      class="cooperation-page__step"
      v-for="step in Number(max)"
      :class="{ active: step == currentStep }"
      :key="step"
      @click="step == currentStep && $emit('click')"
    >
      <span class="cooperation-page__step-num">{{ step }}</span>

      <template v-if="step == currentStep">
        <span class="cooperation-page__step-title">{{$tCooperation('Step')}}</span>
        <span class="cooperation-page__step-tooltip">{{ title }}</span>
      </template>
    </div>

  </div>
</template>

<script>
  export default {
    props: [ 'currentStep', 'title', 'max', 'descriptionShown' ]
  };
</script>
